import { HttpErrorResponse } from '@angular/common/http';
import { BusinessProfile, Organization } from '@iot-platform/models/common';
import { createActionGroup, props } from '@ngrx/store';

export const AuthBusinessProfilesApiActions = createActionGroup({
  source: '[Auth] Business Profiles Api Actions',
  events: {
    loadBusinessProfilesSuccess: props<{ businessProfiles: BusinessProfile[] }>(),
    loadBusinessProfilesFailure: props<{ error: HttpErrorResponse | Error }>(),
    selectBusinessProfileSuccess: props<{ selectedBusinessProfile: BusinessProfile; withRedirect: boolean }>(),
    selectBusinessProfileFailure: props<{ error: HttpErrorResponse | Error }>(),
    loadSelectedEntityForSession: props<{ selectedEntityId: string }>(),
    loadSelectedEntityForSessionSuccess: props<{ selectedEntity: Organization }>(),
    loadSelectedEntityForSessionFailure: props<{ error: HttpErrorResponse | Error }>(),
    loadPerimeterEntitiesSuccess: props<{ entities: Organization[] }>(),
    loadPerimeterEntitiesFailure: props<{ error: HttpErrorResponse | Error }>()
  }
});
